// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vxbq","content":"styles_content__4dTiL"};